<!-- 营销中心 平台营销工具 会员卡订单列表 -->
<template>
  <scroll-layout>
    <template slot="header">
      <ykc-search
        ref="YkcSearch"
        :data="searchData"
        :searchForm="searchParams"
        @click="handleSearchConfirm"
        @clean="handleSearchClean"></ykc-search>
    </template>
    <div>
      <ykc-table
        ref="YkcTable"
        :data="tableData"
        :columns="tableColumns"
        operateFixedType="right"
        :title="`会员卡订单列表`"
        :operateButtons="tableOperateButtons.filter(item => item.enabled())">
        <template #headerButtons>
          <div class="table-header-button">
            <ykc-button
              type="plain"
              v-rbac="'marketing:membercard:order:export'"
              @click="doExportFile">
              导出
            </ykc-button>
          </div>
        </template>
        <ykc-pagination
          slot="pagination"
          ref="YkcPagination"
          :total="pageInfo.total"
          :current-page.sync="pageInfo.pageIndex"
          :page-size.sync="pageInfo.pageSize"
          @current-change="handlePaginationCurrentChange"
          @size-change="handlePaginationSizeChange"></ykc-pagination>
      </ykc-table>

      <!-- 退卡确认弹窗 -->
      <ykc-operation-dialog
        title="会员卡退卡退款确认"
        :show.sync="showRefundDialog"
        :before-confirm="handleRefundConfirm"
        :before-cancel="handleRefundCancel"
        confirm-btn-txt="确认"
        cancel-btn-txt="取消">
        <div slot="content">
          <ykc-form :model="refundForm" :rules="refundRules" ref="refundForm">
            <ykc-form-item label="订单号：" style="color: blue" prop="orderNo">
              <span>{{ refundForm.orderNo }}</span>
            </ykc-form-item>
            <ykc-form-item label="下单手机号：" style="color: red" prop="userAccount">
              <span>{{ refundForm.userAccount }}</span>
            </ykc-form-item>
            <ykc-form-item label="备注：" prop="remark">
              <ykc-input
                type="textarea"
                :rows="4"
                placeholder="请输入，最多120字"
                v-model="refundForm.remark"
                maxlength="120"
                show-word-limit />
            </ykc-form-item>
          </ykc-form>
        </div>
      </ykc-operation-dialog>
    </div>
  </scroll-layout>
</template>

<script>
  import { chargeVipPriceFee, marketManage } from '@/service/apis';
  import { code, offlineExport } from '@/utils';

  export default {
    name: 'memberCardEquityOrderList',
    data() {
      return {
        tableData: [],
        showRefundDialog: false,
        refundForm: {
          id: '',
          orderNo: '',
          userAccount: '',
          remark: '',
        },
        refundRules: {
          remark: [
            { required: true, message: '请输入备注', trigger: 'blur' },
            { max: 120, message: '最多输入120字', trigger: 'blur' },
          ],
        },
        currentRefundRow: null,
        tableColumns: [
          { label: '订单号', prop: 'orderNo', minWidth: '200px' },
          { label: '下单账号', prop: 'userAccount', minWidth: '150px' },
          {
            label: '订单状态',
            prop: 'orderStatus',
            minWidth: '120px',
            scopedSlots: {
              default: ({ row }) => {
                // 订单状态映射
                const statusMap = {
                  1: '待支付',
                  2: '已取消',
                  3: '已完成',
                  4: '售后-全额退款',
                  5: '售后-部分退款',
                };
                return statusMap[row.orderStatus] || row.orderStatus || '--';
              },
            },
          },
          { label: '下单时间', prop: 'createdTime', minWidth: '180px' },
          { label: '会员卡类型', prop: 'vipTypeName', minWidth: '150px' },
          { label: '会员卡号', prop: 'cardNo', minWidth: '150px' },
          {
            label: '会员卡状态',
            prop: 'cardStatus',
            minWidth: '120px',
            scopedSlots: {
              default: ({ row }) => {
                // 会员卡状态映射
                const statusMap = {
                  0: '未激活',
                  1: '生效中',
                  2: '未生效',
                  3: '已退卡',
                  4: '已过期',
                };
                return statusMap[row.cardStatus] || row.cardStatus || '——';
              },
            },
          },
          { label: '生效时间', prop: 'startTime', minWidth: '180px' },
          { label: '失效时间', prop: 'endTime', minWidth: '180px' },
          { label: '可退金额', prop: 'wxRefundAmount', minWidth: '120px' },
          { label: '售后退卡时间', prop: 'refundTime', minWidth: '180px' },
          { label: '退卡原因', prop: 'refundReason', minWidth: '150px' },
          { label: '退卡操作人', prop: 'operatorBy', minWidth: '150px' },
        ],
        pageInfo: {
          total: 0,
          pageIndex: 1,
          pageSize: 10,
        },
        searchParams: {
          date: [],
          effectiveTime: [],
          expireTime: [],
          createdStartTime: '',
          createdEndTime: '',
          startTopTime: '',
          startDownTime: '',
          endTopTime: '',
          endDownTime: '',
          orderNo: '',
          userAccount: '',
          cardNo: '',
          cardStatus: '',
          orderStatus: '',
          vipType: '',
          recordIds: [],
        },
        tableOperateButtons: [
          {
            enabled: () => code('marketing:membercard:equity:refund'),
            render: (h, button, { row }) => {
              // 未配置无详情
              if (String(row.isRefundCard) === '1') {
                return (
                  <ykc-button
                    type="text"
                    onClick={() => {
                      this.handleRefund(row);
                    }}>
                    退卡退款
                  </ykc-button>
                );
              }
              return null;
            },
          },
        ],
      };
    },
    computed: {
      searchData() {
        return [
          {
            comName: 'YkcInput',
            key: 'orderNo',
            label: '订单号',
            placeholder: '请输入订单号',
          },
          {
            comName: 'YkcInput',
            key: 'userAccount',
            label: '下单账号',
            placeholder: '请输入下单账号',
          },
          {
            clearable: true,
            comName: 'YkcDropdown',
            key: 'orderStatus',
            label: '订单状态',
            placeholder: '请选择订单状态',
            data: [
              { id: '', name: '全部' },
              { id: '1', name: '待支付' },
              { id: '2', name: '已取消' },
              { id: '3', name: '已完成' },
              { id: '4', name: '售后-全额退款' },
              { id: '5', name: '售后-部分退款' },
            ],
          },
          {
            clearable: true,
            comName: 'YkcDropdown',
            key: 'vipType',
            label: '会员卡类型',
            placeholder: '请选择会员卡类型',
            data: [
              { id: '', name: '全部' },
              { id: '001', name: '月卡' },
              { id: '002', name: '季卡' },
              { id: '003', name: '年卡' },
            ],
          },
          {
            comName: 'YkcInput',
            key: 'cardNo',
            label: '会员卡号码',
            placeholder: '请输入会员卡号码',
          },
          {
            clearable: true,
            comName: 'YkcDropdown',
            key: 'cardStatus',
            label: '会员卡状态',
            placeholder: '请选择',
            data: [
              { id: '', name: '全部' },
              { id: '1', name: '生效中' },
              { id: '2', name: '未生效' },
              { id: '3', name: '已退卡' },
              { id: '4', name: '已过期' },
            ],
          },
          {
            comName: 'YkcDatePicker',
            key: 'date',
            label: '下单时间',
            placeholder: '请选择下单时间',
          },
          {
            comName: 'YkcDatePicker',
            key: 'effectiveTime',
            label: '生效时间',
            placeholder: '请选择下单时间',
          },
          {
            comName: 'YkcDatePicker',
            key: 'expireTime',
            label: '失效时间',
            placeholder: '请选择下单时间',
          },
        ];
      },
    },
    created() {
      // 初始化时间范围为近30天
      const startDate = this.getLastTime('yyyy-MM-dd', 30);
      const endDate = this.getLastTime('yyyy-MM-dd', 0);
      this.searchParams.date = [startDate, endDate];
      this.searchParams.createdStartTime = startDate;
      this.searchParams.createdEndTime = endDate;
      this.searchParams.effectiveTime = [];
      this.searchParams.startTopTime = '';
      this.searchParams.startDownTime = '';
      this.searchParams.expireTime = [];
      this.searchParams.endTopTime = '';
      this.searchParams.endDownTime = '';
      // 页面跳转传参
      if (this.$route.query.data) {
        const query = JSON.parse(this.$route.query.data);
        console.log('query+++', query);
        if (query.recordIds && query.recordIds !== null) {
          this.searchParams.recordIds = query.recordIds;
        }
      }
      this.requestList();
    },
    methods: {
      /**
       * 获取近N天日期
       */
      getLastTime(fmt, day) {
        const now = new Date();
        const target = new Date(now.getTime() - day * 24 * 60 * 60 * 1000);
        const y = target.getFullYear();
        const m = target.getMonth() + 1;
        const d = target.getDate();
        if (fmt === 'yyyy-MM-dd') {
          return `${y}-${m.toString().padStart(2, '0')}-${d.toString().padStart(2, '0')}`;
        }
        return target;
      },

      /**
       * 点击筛选查询按钮
       */
      handleSearchConfirm(searchData) {
        this.pageInfo.pageIndex = 1;
        Object.assign(this.searchParams, searchData);

        if (searchData.date && searchData.date.length > 0) {
          [this.searchParams.createdStartTime, this.searchParams.createdEndTime] = searchData.date;
        } else {
          delete this.searchParams.createdStartTime;
          delete this.searchParams.createdEndTime;
        }
        if (searchData.effectiveTime && searchData.effectiveTime.length > 0) {
          [this.searchParams.startTopTime, this.searchParams.startDownTime] =
            searchData.effectiveTime;
        } else {
          delete this.searchParams.startTopTime;
          delete this.searchParams.startDownTime;
        }
        if (searchData.expireTime && searchData.expireTime.length > 0) {
          [this.searchParams.endTopTime, this.searchParams.endDownTime] = searchData.expireTime;
        } else {
          delete this.searchParams.endTopTime;
          delete this.searchParams.endDownTime;
        }
        this.requestList();
      },

      /**
       * 点击清空查询按钮
       */
      handleSearchClean(form) {
        Object.assign(this.searchParams, form);

        // 近30天初始化时间
        const startDate = this.getLastTime('yyyy-MM-dd', 30);
        const endDate = this.getLastTime('yyyy-MM-dd', 0);

        this.searchParams.date = [startDate, endDate];
        this.searchParams.createdStartTime = startDate;
        this.searchParams.createdEndTime = endDate;
        this.searchParams.effectiveTime = [];
        this.searchParams.startTopTime = '';
        this.searchParams.startDownTime = '';
        this.searchParams.expireTime = [];
        this.searchParams.endTopTime = '';
        this.searchParams.endDownTime = '';
      },

      /**
       * 分页器页数
       */
      handlePaginationCurrentChange(current) {
        this.pageInfo.pageIndex = current;
        this.requestList();
      },

      /**
       * 分页器条数
       */
      handlePaginationSizeChange(size) {
        this.pageInfo.pageIndex = 1;
        this.pageInfo.pageSize = size;
        this.requestList();
      },

      /**
       * 请求列表数据
       */
      requestList() {
        const reqParams = {
          ...this.searchParams,
          current: this.pageInfo.pageIndex,
          size: this.pageInfo.pageSize,
        };

        marketManage
          .getVipCardOrderPage(reqParams)
          .then(res => {
            this.tableData = res.records || [];
            this.pageInfo.total = res.total || 0;
          })
          .catch(err => {
            console.log(err);
            this.tableData = [];
            this.pageInfo.total = 0;
          });
      },

      doExportFile() {
        offlineExport({
          downloadType: 'marketing_export',
          jsonNode: {
            downloadKey: 'vip_card_order_export',
            ...this.searchParams,
          },
        });
      },

      /**
       * 查看详情
       */
      handleViewDetail(row) {
        // TODO: 跳转到会员卡订单详情页面
        this.$message.info('详情功能待开发');
      },

      /**
       * 处理退卡申请
       */
      handleRefund(row) {
        // 可以退卡，显示退卡确认弹窗
        this.currentRefundRow = row;
        this.refundForm.id = row.id;
        this.refundForm.orderNo = row.orderNo;
        this.refundForm.userAccount = row.userAccount;
        this.refundForm.remark = '';

        // 显示退卡确认弹窗
        this.showRefundDialog = true;
      },

      /**
       * 退卡确认
       */
      handleRefundConfirm() {
        // 表单验证
        this.$refs.refundForm.validate(valid => {
          if (valid) {
            // 调用退卡API
            chargeVipPriceFee
              .vipWebRefundCard({
                id: this.refundForm.id,
                refundReason: this.refundForm.remark,
              })
              .then(res => {
                this.$message.success('退卡成功');
                this.showRefundDialog = false;
                // 重新加载列表
                this.requestList();
                console.log('res', res);
              });
          }
        });

        // 返回Promise以符合组件要求
        return Promise.resolve();
      },

      /**
       * 退卡取消
       */
      handleRefundCancel() {
        this.showRefundDialog = false;
        this.refundForm.remark = '';

        // 返回Promise以符合组件要求
        return Promise.resolve();
      },
    },
  };
</script>

<style lang="scss" scoped>
  .status-red {
    color: #d0021b;
  }
</style>
